(function () {
  if (window.__ksHideSmileOnCartDrawer) return;
  window.__ksHideSmileOnCartDrawer = true;

  const LOG = '[KS Hide Smile Rewards]';

  const smileSelectors = [
    '#smile-ui-lite-launcher-frame-container',
    '#smile-lite-launcher-frame',
    '[id*="smile-ui-lite-launcher"]',
    '[id*="smile-lite-launcher"]'
  ];

  function getCartDrawer() {
    return (
      document.querySelector('cart-drawer#cart-drawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('.drawer--cart')
    );
  }

  function isCartDrawerOpen() {
    const drawer = getCartDrawer();

    if (!drawer) return false;

    return (
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('drawer--is-open') ||
      drawer.classList.contains('is-active') ||
      drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.hasAttribute('open')
    );
  }

  function getSmileLaunchers() {
    const launchers = [];

    smileSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (!launchers.includes(el)) {
          launchers.push(el);
        }
      });
    });

    return launchers;
  }

  function updateSmileVisibility() {
    const shouldHide = isCartDrawerOpen();
    const launchers = getSmileLaunchers();

    launchers.forEach(el => {
      if (shouldHide) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('data-ks-hidden-by-cart-drawer', 'true');
      } else if (el.getAttribute('data-ks-hidden-by-cart-drawer') === 'true') {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
        el.removeAttribute('data-ks-hidden-by-cart-drawer');
      }
    });
  }

  function startObserver() {
    const drawer = getCartDrawer();

    const observer = new MutationObserver(function () {
      window.clearTimeout(window.__ksSmileDrawerTimer);
      window.__ksSmileDrawerTimer = window.setTimeout(updateSmileVisibility, 50);
    });

    if (drawer) {
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'open', 'hidden']
      });
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    updateSmileVisibility();

    console.log(LOG, 'Initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  setTimeout(updateSmileVisibility, 500);
  setTimeout(updateSmileVisibility, 1500);
})();